export const makeAction = (type) => (payload) => ({
  type,
  payload,
});

export const success = (actionName) => `${actionName}_SUCCESS`;

export const failed = (actionName) => `${actionName}_FAILED`;
